import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function LoginFooter() {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: { xs: 24, md: 32 },
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        zIndex: 1,
      }}
    >
      <Typography
        sx={{ color: '#d3d3d3', fontSize: 12.875, lineHeight: '39.698px', fontWeight: 400 }}
      >
        Powered by
      </Typography>
      <Typography
        sx={{
          color: '#fff',
          fontSize: 14,
          fontWeight: 600,
          letterSpacing: '-0.02em',
        }}
      >
        officebanao
      </Typography>
    </Box>
  );
}
